<shared-auth-wrapper class="auth-for-unique-code-error">
    <ng-container *ngIf="(errorType$ | async) === 0">
        <div class="auth-for-unique-code-error__animation" directive-lottie="error-link-expired"></div>
    </ng-container>

    <ng-container *ngIf="(errorType$ | async) === 1">
        <div class="auth-for-unique-code-error__animation" directive-lottie="error-sign-up"></div>
    </ng-container>

    <ng-template #preHeader>
        {{label}}
    </ng-template>
    <shared-auth-header [center]="true" type="3" [preHeader]="preHeader">{{errorText$ | async}}</shared-auth-header>

    <shared-btn (onClick)="handleSignInClick($event)">Sign in / up</shared-btn>
</shared-auth-wrapper>